import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { ROUTE_ENTITY_MAPPING } from '../utils/constants';

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  if (
    !(
      to.name === 'knowledge-viewer' ||
      (!!to.name && ROUTE_ENTITY_MAPPING[to.name])
    )
  )
    return next();

  const { path, query, hash } = to;

  if (!from.name || query.noSave || query.silent) return next();

  const routeQuery = {
    force: query.force || '0',
    skipOrdered: query.skipOrdered || '0',
    deepLoading: query.deepLoading || '0',
    modalBack: query.modalBack || '0',
    mainBack: query.mainBack || '0',
    modalContentId: query.modalContentId || '-1',
    modalAnswerId: query.modalAnswerId || '-1',
  };

  const configStore = useConfigStore();
  configStore.pushLastEntityRoute({
    path,
    query: routeQuery,
    hash,
  });
  next();
};
